/** @format */

import { useEffect, useMemo, useState } from 'react';
import {
  getDeviceDetectSnapshot,
  MOBILE_MAX_WIDTH_PX,
  TABLET_MAX_WIDTH_PX,
  type DeviceDetectSnapshot
} from 'src/utils/deviceDetect';

const useDeviceDetect = (): DeviceDetectSnapshot => {
  const [snapshot, setSnapshot] = useState(getDeviceDetectSnapshot);

  useEffect(() => {
    const sync = () => setSnapshot(getDeviceDetectSnapshot());

    const mobileQuery = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH_PX}px)`);
    const tabletQuery = window.matchMedia(
      `(min-width: ${MOBILE_MAX_WIDTH_PX + 1}px) and (max-width: ${TABLET_MAX_WIDTH_PX}px)`
    );

    mobileQuery.addEventListener('change', sync);
    tabletQuery.addEventListener('change', sync);
    window.addEventListener('resize', sync);

    return () => {
      mobileQuery.removeEventListener('change', sync);
      tabletQuery.removeEventListener('change', sync);
      window.removeEventListener('resize', sync);
    };
  }, []);

  return useMemo(() => snapshot, [snapshot]);
};

export default useDeviceDetect;
